// extracted by mini-css-extract-plugin
export default {"accessibleGroupsContainer":"AccessibleGroups_accessibleGroupsContainer__TJ7yQ","formsDataContainer":"AccessibleGroups_formsDataContainer__n1zGH"};